import React, { useContext, useEffect, useState } from 'react';
import { Form, Label } from 'semantic-ui-react';
import { uniqueKey } from '../../../common/keys';
import { gEnums } from '../../../enums/globalEnums';
import { listList } from '../../../lists/lists';
import { ParentContext } from 'global/cnr/contexts/ParentContext';

const ThemedColors = (props) => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { themeColors } = aps_global ?? {}

  const { fip, itemProp } = props
  const { data } = itemProp ?? {}
  const { formItemType } = data ?? {}
  const { value, propindex } = fip

  const _formItemType = props?.formItemType || formItemType

  const [colors, setColors] = useState(value || {})

  useEffect(() => {
    setColors(fip.value)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [fip?.value]);

  let options = []

  const { backgroundColor, color, apply } = colors ?? {}

  const handleApply = () => {
    const nc = { ...colors }
    nc.apply = !nc.apply
    setColors(nc)

    const x = {
      propname: fip.propname,
      value: nc,
      propindex: propindex
    }

    console.log('x', x)

    fip.onChange(fip.propname, x)
  }

  const handle_change = (e, data) => {

    const { propname, value, checked } = data

    const newColors = {
      backgroundColor: colors?.backgroundColor,
      color: colors?.color,
      apply: colors?.apply,
    }

    switch (propname) {
      case 'color':
      case 'indicatorIconColor':
      case 'indicatorIconColor':
        newColors.color = value
        break;
      case 'apply':
        newColors.apply = checked
        break;
      default:
        newColors.backgroundColor = value
    }

    setColors(newColors)

    const x = {
      propname: fip.propname,
      value: newColors,
      propindex: propindex,
    }

    console.log('newColors', newColors)
    console.log('x ', x)

    // fip.onChange(e, newColors)
    fip.onChange(fip.propname, newColors)
  }

  try {
    options = listList(Object.keys(themeColors))
    options.forEach(opt => {
      opt.icon = {
        name: 'circle',
        style: { color: themeColors[opt.value], padding: 0 }
      }
      opt.style = { padding: 2 }
    })
  } catch (error) {
    console.error(error)
  }

  const select = (keyy, propname, v, o, s, hc, label) => {
    return <Form.Select
      label={label}
      key={uniqueKey(keyy)}
      onChange={hc}
      value={v}
      propname={propname}
      fluid
      options={o}
      style={s}
      itemProp={itemProp}
    />
  }

  const labelStyle = () => {
    switch (_formItemType) {
      case gEnums.formItemTypes.colorSelectSingle:
        return {
          backgroundColor: themeColors?.[color] || 'grey',
          color: themeColors?.[color] || 'black',
        }
      default:
        return {
          backgroundColor: themeColors?.[backgroundColor] || 'grey',
          color: themeColors?.[color] || 'black',
        }
    }
  }

  const lbl = (keyy) => <Label
    className='lbl-color-sel'
    key={uniqueKey(keyy)}
    style={labelStyle()}
    onClick={() => { handleApply() }}
    placeholder={'apply'}
  >
    {'colors'}
  </Label>

  const colorItems = () => {
    const items = []
    switch (_formItemType) {
      case gEnums.formItemTypes.colorSelectSingle:
        // nothing
        break;
      default:
        items.push(<div key={uniqueKey('ci', 1)} className={'colorz-bc'}>{select('fs-tc-bc' + fip.propname, 'backgroundColor', backgroundColor, options, null, handle_change, 'Background')}</div>)
    }

    items.push(<div key={uniqueKey('ci', 2)} className={'colorz-c'}>{select('fs-tc-c' + fip.propname, 'color', color, options, null, handle_change, 'Color')}</div>)

    return <React.Fragment>
      {items}
    </React.Fragment>
  }

  const colorsContainer = () => {
    const keyy = 'fs-tc' + fip.propname
    let cn = 'colorz-apply'
    if (apply) { cn += ' applied' }
    return <div key={uniqueKey(keyy)} className={'colorz-container ' + _formItemType} >
      <div className={cn}>{lbl('fs-tc-l' + fip.propname)}</div>
      {colorItems()}
    </div>
  }

  const x = () => {
    const keyy = 'fs-tc-f' + fip.propname
    return <div key={uniqueKey(keyy)} className={'field'}>
      <label>{fip.label}</label>
    </div>
  }

  return <div keyy={'fs-tc-d' + fip.propname}>
    {x()}
    {colorsContainer()}
  </div>
}

export default ThemedColors